import { useState, useEffect, useCallback } from 'react';
import { API } from '../api/config';

const API_BASE_URL = API.LUDOPEDIA;



const ROWS_PER_PAGE = 12;

/**
 * Constrói a URL da API para buscar jogos.
 * @param {object} params - Os parâmetros de filtro (search, duracao, etc).
 * @param {number} page - O número da página atual.
 * @returns {string} A URL completa da API.
 */

function buildApiUrl(params, page) {
    const queryParams = new URLSearchParams();

    if (params.search) queryParams.append('search', params.search);
    if (params.tp_jogo) queryParams.append('tp_jogo', params.tp_jogo);
    if (params.qt_jogadores) queryParams.append('qt_jogadores', params.qt_jogadores);
    if (params.duracao) queryParams.append('duracao', params.duracao);
    if (params.complexidade) queryParams.append('complexidade', params.complexidade);
    if (params.tipo) queryParams.append('tipo', params.tipo);
    

    queryParams.append('rows', ROWS_PER_PAGE);
    queryParams.append('page', page);

    return `${API_BASE_URL}/jogos?${queryParams.toString()}`;
}

export function useGameCatalogue() {
    const [games, setGames] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [searchParams, setSearchParams] = useState({ search: '', duracao: '', qt_jogadores: '' });
    const [currentPage, setCurrentPage] = useState(1);
    const [hasNextPage, setHasNextPage] = useState(true);
    const [isFetchingMore, setIsFetchingMore] = useState(false); 

    useEffect(() => {
        const fetchGames = async () => {
            if (currentPage === 1) {
                setIsLoading(true);
            } else {
                setIsFetchingMore(true);
            }

            const apiUrl = buildApiUrl(searchParams, currentPage);
            try {
                const response = await fetch(apiUrl);
                const data = await response.json();
                if (currentPage === 1) {
                    setGames(data.jogos || []);
                } else {
                    setGames(prevGames => [...prevGames, ...(data.jogos || [])]);
                }
                
                setHasNextPage(data.has_next_page || false); 

            } catch (error) {
                console.error("Erro ao buscar jogos:", error);
            } finally {
                setIsLoading(false);
                setIsFetchingMore(false);
            }
        };

        fetchGames();
    }, [searchParams, currentPage]);

    const handleSearchChange = useCallback((newParams) => {
        setSearchParams(newParams);
        setCurrentPage(1);
    }, []);

    const loadMoreGames = useCallback(() => {
        if (!isFetchingMore && hasNextPage) {
            setCurrentPage(prevPage => prevPage + 1);
        }
    }, [isFetchingMore, hasNextPage]);
    
    return { 
        games, 
        isLoading, 
        isFetchingMore,
        hasNextPage,
        searchParams,
        handleSearchChange, 
        loadMoreGames
    };
}